module.exports = __webpack_public_path__ + "img/4_1.d44074fb.jpg";